import { AuthSDKController } from './AuthSDKController';
import { AuthSDKService } from './AuthSDKService';
import { AuthSDKEvents } from './AuthSDKEvents';
import type { loginParams } from '../model/authSDKModels';
import { computed } from 'vue';

const sendedOtpData = ref();

export const useAuthSDK = () => {
  const api = AuthSDKService.getInstance();
  const authSDKController = AuthSDKController.getInstance(api);

  const isAuthorized = computed(() => authSDKController.isAuthorized());
  const isValid = computed(() => authSDKController.isValid());

  const onAuth = (callback: () => void) => {
    AuthSDKEvents.auth.on(callback);
  };

  const onLogout = (callback: () => void) => {
    AuthSDKEvents.logout.on(callback);
  };

  const onInit = (callback: (event: { isAuthorized: boolean }) => void) => {
    callback({ isAuthorized: authSDKController.isAuthorized() });
  };

  const sendOtp = async (phone: string, captcha: string) => {
    await authSDKController.sendOtp(phone, captcha);
  };

  const verifyOtp = async (otp: string) => {
    const response = await authSDKController.verifyOtp(otp);
    return response;
  };

  const logout = () => {
    authSDKController.logout();
  };

  const refreshTokens = async () => {
    await authSDKController.refreshTokens();
  };

  function updateSendedOtpData() {
    const data = authSDKController.getSendedOtpData();
    sendedOtpData.value = data;
    return data;
  }
  updateSendedOtpData();
  
  const magnitIdCode = authSDKController.magnitIdCode;

  /** Используется напрямую только после регистрации пользователя (форма profile-filling-step) */
  async function login(params: loginParams) {
    await authSDKController.login(params);
  }

  return {
    authSDKController,
    isAuthorized,
    isValid,
    onAuth,
    onLogout,
    onInit,
    sendOtp,
    verifyOtp,
    logout,
    refreshTokens,
    sendedOtpData,
    updateSendedOtpData,
    magnitIdCode,
    login,
  };
};
